import cashierSelectors from 'features/cashier/services/selectors';
import paymentActions from 'features/payment/services/actions';
import { useAppDispatch } from 'store/hooks';
import CashierActionButton from '../CashierActionBtn';
import { useTicketWrapper } from 'features/ShopWrapperLayout/TicketWrapperContext';
type Props = {
  v2?: boolean;
};
const ButtonPrint = ({ v2 }: Props) => {
  const dispatch = useAppDispatch();
  const ticketContext = useTicketWrapper();
  const ticketDetailStore = cashierSelectors.getTicketDetails();
  const onVoidTicket = async () => {
    if (!ticketDetailStore?.ticketInfo.billId) return;
    ticketContext.printWithoutCoupon(ticketDetailStore?.ticketInfo.billId);
    // dispatch(
    //   // @ts-ignore
    //   paymentActions.getInfoPrintWaiting.fetch({
    //     body: JSON.stringify({ id: ticketDetailStore?.ticketInfo.billId, type: 'PENDING_TICKET' }),
    //   })
    // );
  };

  if (!ticketDetailStore?.ticketInfo.billId) return null;

  return (
    <>
      <CashierActionButton
        label='Print'
        onClick={onVoidTicket}
        ntype='ORANGE'
        v2UI={v2}
        feature='PRINT'
      />
    </>
  );
};

export default ButtonPrint;
